import React, {ReactElement} from 'react';
import {makeStyles} from '@material-ui/core/styles';

type StylesProps = {
  readonly fullWidth?: boolean;
  readonly centered?: boolean;
};

const useStyles = makeStyles({
  image: {
    display: 'block',
    maxWidth: '100%',
    width: (props: StylesProps) => (props.fullWidth ? '100%' : 'auto'),
    height: 'auto',
    marginLeft: (props: StylesProps) => (props.centered ? 'auto' : '0'),
    marginRight: (props: StylesProps) => (props.centered ? 'auto' : '0')
  }
});

type Props = {
  readonly alt: string;
  readonly className?: string;
  readonly src: string;
  readonly fullWidth?: boolean;
  readonly centered?: boolean;
};

ResponsiveImage.defaultProps = {
  className: '',
  fullWidth: false,
  centered: true
};

function ResponsiveImage({alt, className, src, fullWidth, centered}: Props): ReactElement {
  const classes = useStyles({fullWidth, centered});
  return <img alt={alt} className={`${className} ${classes.image}`} src={src} title={alt} />;
}

export default ResponsiveImage;
